import type { InventoryQuerySchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';

export const fieldNames: Record<keyof InventoryQuerySchema, { name: string; revertible: boolean }> = {
  id: {
    name: 'ID',
    revertible: false,
  },
  name: {
    name: 'Name',
    revertible: true,
  },
  committed: {
    name: 'Committed',
    revertible: false,
  },
  current_stock: {
    name: 'Current Stock',
    revertible: true,
  },
  status: {
    name: 'Status',
    revertible: true,
  },
  description: {
    name: 'Description',
    revertible: true,
  },
  primary_sku: {
    name: 'Primary SKU',
    revertible: false,
  },
  secondary_skus: {
    name: 'Secondary SKUs',
    revertible: true,
  },
  last_order_cost: {
    name: 'Last Order Cost',
    revertible: true,
  },
  weight: {
    name: 'Weight',
    revertible: true,
  },
  inventory_volume: {
    name: 'Inventory Volume',
    revertible: true,
  },
  inventory_volume_id: {
    name: 'Inventory Volume ID',
    revertible: false,
  },

  images: {
    name: 'Images',
    revertible: true,
  },

  category_id: {
    name: 'Category ID',
    revertible: false,
  },

  inventory_category: {
    name: 'Inventory Category',
    revertible: true,
  },

  vendors: {
    name: 'Vendors',
    revertible: true,
  },
  vendor_details: {
    name: 'Vendor Details',
    revertible: false,
  },
  minimum_stock: {
    name: 'Minimum Stock',
    revertible: true,
  },
  maximum_stock: {
    name: 'Maximum Stock',
    revertible: true,
  },
  units_per_order: {
    name: 'Units per Order',
    revertible: false,
  },
  minimum_order: {
    name: 'Minimum Order',
    revertible: true,
  },
  bin_locations: {
    name: 'Bin Locations',
    revertible: true,
  },
  track_serial_numbers: {
    name: 'Track Serial Numbers',
    revertible: false,
  },
  track_stock_quantities: {
    name: 'Track Stock Quantities',
    revertible: false,
  },

  logo: {
    name: 'Logo',
    revertible: true,
  },

  manufacturer: {
    name: 'Manufacturer',
    revertible: true,
  },
  manufacturer_id: {
    name: 'Manufacturer ID',
    revertible: false,
  },
  discontinued: {
    name: 'Discontinued',
    revertible: true,
  },

  brand: {
    name: 'Brand',
    revertible: true,
  },
  brand_id: {
    name: 'Brand ID',
    revertible: false,
  },
  parent: {
    name: 'Parent',
    revertible: false,
  },
  parent_id: {
    name: 'Parent ID',
    revertible: false,
  },
  children: {
    name: 'Sub Items',
    revertible: false,
  },
};
